import { apiRequest } from "./client";

/**
 * Team & invites (Sprint 11, Part 91):
 * - GET    /api/org/members
 * - POST   /api/org/members             {fullName, email, role}
 * - PATCH  /api/org/members/:id         {role}
 * - DELETE /api/org/members/:id
 * - POST   /api/auth/accept-invite      {token, password}  (public)
 */

export const teamApi = {
  async listMembers() {
    const data = await apiRequest("/api/org/members");
    return (data?.items || []).map((m) => ({ ...m }));
  },

  async inviteMember(payload) {
    return apiRequest("/api/org/members", {
      method: "POST",
      body: JSON.stringify(payload),
    });
  },

  async updateRole(memberId, role) {
    return apiRequest(`/api/org/members/${memberId}`, {
      method: "PATCH",
      body: JSON.stringify({ role }),
    });
  },

  async removeMember(memberId) {
    return apiRequest(`/api/org/members/${memberId}`, { method: "DELETE" });
  },

  async acceptInvite(payload) {
    return apiRequest("/api/auth/accept-invite", {
      method: "POST",
      body: JSON.stringify(payload),
    });
  },
};
